import { useQuery } from '@tanstack/react-query';

import { getTimeOffBalanceByType } from '../api/time-offs.api';
import { getTimeOffBalanceByTypeQueryKey } from '../constants/time-offs-query-keys';

/** Balances change only on booking/cancellation (which invalidate the tree), so
 *  cache them to avoid refetching on every mount during rapid navigation. */
const BALANCE_STALE_TIME = 5000 * 60; // 5 minutes

/**
 * Fetches the current user's balance for a single time-off type. Powers the
 * "Your balance" card on the request details screen. Disabled until a valid
 * type id is available.
 */
export const useTimeOffBalanceByType = (typeId: number | undefined) => {
  return useQuery({
    queryKey: getTimeOffBalanceByTypeQueryKey(typeId ?? 0),
    queryFn: () => getTimeOffBalanceByType(typeId as number),
    enabled: typeof typeId === 'number' && !Number.isNaN(typeId),
    staleTime: BALANCE_STALE_TIME,
  });
};
